import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import TextInput from '../../components/FormElements/TextInput';
import Logo from '../../components/Branding/Logo'; // Import the Logo component
// import './NewPasswordScreen.css'; // Ensure this file exists or styles are globally available

function NewPasswordScreen() {
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: '',
    });
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    // const { token } = useParams(); // Example: if the reset token is part of the URL
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        }
        if (message) setMessage('');
    };

    const toggleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setMessage('');
        let currentErrors = {};

        if (!formData.newPassword) {
            currentErrors.newPassword = 'La nueva contraseña es requerida.';
        } else if (formData.newPassword.length < 8) { // Example: min length validation
            currentErrors.newPassword = 'La contraseña debe tener al menos 8 caracteres.';
        }

        if (!formData.confirmPassword) {
            currentErrors.confirmPassword = 'Debes confirmar la nueva contraseña.';
        } else if (formData.newPassword && formData.newPassword !== formData.confirmPassword) {
            currentErrors.confirmPassword = 'Las contraseñas no coinciden.';
        }

        if (Object.keys(currentErrors).length > 0) {
            setErrors(currentErrors);
            return;
        }

        setIsLoading(true);
        console.log('Setting new password:', formData.newPassword);
        // console.log('Using token:', token); // If applicable

        // TODO: Implement actual password setting logic (e.g., API call with token)
        try {
            await new Promise(resolve => setTimeout(resolve, 1500)); // Simulate API call
            setMessage('Tu contraseña ha sido restablecida exitosamente.');
            setFormData({ newPassword: '', confirmPassword: '' }); // Clear fields
            // Optional: Redirect after a short delay
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            // const errorMessage = error.response?.data?.message || 'Ocurrió un error al restablecer la contraseña.';
            setMessage('Error al restablecer la contraseña. Por favor, inténtalo de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="col-md-7 col-lg-7 col-xl-7 mx-auto d-flex justify-content-center align-items-center">
            <div className="form-container text-center">
                <Logo /> {/* Using the imported Logo component */}

                <h2 className="text-center mb-2">Establecer Nueva Contraseña</h2>
                <p className="text-muted mb-4">
                    Por favor, ingresa y confirma tu nueva contraseña a continuación.
                </p>

                {message && (
                    <div className={`alert ${message.startsWith('Error') ? 'alert-danger' : 'alert-success'} mb-3`} role="alert">
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="checkin-form text-start">
                    <TextInput
                        label="Nueva Contraseña"
                        type={showNewPassword ? 'text' : 'password'}
                        id="newPassword"
                        name="newPassword"
                        value={formData.newPassword}
                        onChange={handleChange}
                        required
                        error={errors.newPassword}
                        iconClass={`bi ${showNewPassword ? 'bi-eye' : 'bi-eye-slash'}`}
                        onIconClick={toggleNewPasswordVisibility}
                        iconAriaLabel="Mostrar u ocultar nueva contraseña"
                    />
                    <TextInput
                        label="Confirmar Nueva Contraseña"
                        type={showConfirmPassword ? 'text' : 'password'}
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        error={errors.confirmPassword}
                        iconClass={`bi ${showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'}`}
                        onIconClick={toggleConfirmPasswordVisibility}
                        iconAriaLabel="Mostrar u ocultar confirmación de contraseña"
                    />
                    <button type="submit" className="btn btn-checkin w-100 mt-4" disabled={isLoading}>
                        {isLoading ? 'Estableciendo...' : 'Establecer Contraseña'}
                    </button>
                </form>
                <div className="text-center mt-3">
                    <Link to="/" className="text-decoration-none" style={{ color: 'var(--color-texto-secundario)' }}>Volver al inicio</Link>
                </div>
            </div>
        </div>
    );
}

export default NewPasswordScreen;